/* eslint-disable import/no-anonymous-default-export */
import http from "../../helpers/http";
import qs from 'qs'

export default {
    getKeterangan: (token, search, limit) => ({
        type: 'GET_KETERANGAN',
        payload: http(token).get(`/ket/all?search=${search}&limit=${limit}`)
    }),
    addKeterangan: (token, data) => ({
        type: 'ADD_KETERANGAN',
        payload: http(token).post(`/ket/add`, qs.stringify(data))
    }),
    updateKeterangan: (token, id, data) => ({
        type: 'UPDATE_KETERANGAN',
        payload: http(token).patch(`/ket/update/${id}`, qs.stringify(data)),
    }),
    deleteKeterangan: (token, id, data) => ({
        type: 'DELETE_KETERANGAN',
        payload: http(token).delete(`/ket/delete/${id}`, qs.stringify(data)),
    }),
    getDetailKeterangan: (token, id) => ({
        type: 'GET_DETAIL_KETERANGAN',
        payload: http(token).get(`/ket/detail/${id}`)
    }),
    nextPage: (token, link) => ({
        type: 'NEXT_DATA_KETERANGAN',
        payload: http(token).get(`${link}`)
    }),
    resetError: () => ({
        type: 'RESET_KETERANGAN'
    })
}